/**
 * @file: 类型 和 状态 显示标签
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/08/29      1.0     First version
 *
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
import Lang from "@/components/Lang/Lang";
import "./statuBuyerLabel.less"
/**
 * Essaone 新客户标签类型 标签
 * essaone_new_buyer_label_type: [ "10" : "待初步联系", "20" : "保持联系", "30" : "选品", 40" : "下单" ,"50"  "成交实现","60" : "成交未实现","70" : "跟进失败" ]
 * @param statusCode 状态码
 * @param status 状态
 *
 *
 * */
const NewBuyerLabel = ({statusCode="",status="",className="",}) => {
    return (<span className={`labelBuyerSpan labelSpan_${statusCode}${className?" "+className:""}`}>
           {status}
       </span>)
}

/**
 * 潜在客户 标签
 * essaone_new_buyer_label_type: [ 10:待初步联系 20:跟进中 30:成功注册 40: 跟进失败]
 * @param statusCode 状态码
 * @param status 状态
 *
 *
 * */
const InternalBuyerLabel = ({statusCode="",status="",className="",}) => {
    return (<span className={`labelBuyerSpan InternalBuyerLabel_${statusCode}${className?" "+className:""}`}>
           {status}
       </span>)
}

/**
 * Essaone 成交客户阶段 标签
 * essaone_buyer_label_type: [ "10" : "新客", "20" : "成长客户", "30" : "留存客户", 40" : "预流失客户" ,"50"  "已流失客户",]
 * @param statusCode 状态码
 * @param status 状态
 *
 * */
const TransactionCustomerStage = ({statusCode="",status="",className="",}) => {
    return (<span className={`labelBuyerSpan labelSpan_${statusCode}${className?" "+className:""}`}>
           {status}
       </span>)
}

/**
 * 客户状态 标签(是否目标用户)
 * @param isTarget : 0 否，1 是，其他 ：暂未确认
 * */
const noVer = ()=>{
    return (
        <svg t="1734075821241" className="icon font_20 mr_4" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="25666" width="18" height="18">
            <path
                d="M511.5904 1023.999898c-21.811196 0-43.622391-6.451199-62.207987-19.455997L258.048051 869.222329c-123.084775-97.484781-189.183962-232.806353-189.183962-383.231924V256.051251c0-42.700791 26.111995-82.636783 64.972787-99.43038L467.968009 9.6257a105.599979 105.599979 0 0 1 88.319982 0.1024l334.079933 146.995171c39.270392 16.947197 64.767987 56.012789 64.767987 99.32798v230.604754c0 150.93757-66.918387 286.566343-188.518362 381.900724l-192.511961 135.782373A108.784618 108.784618 0 0 1 511.5904 1023.999898z m0.3072-955.699009c-5.375999 0-10.751998 1.1776-15.718397 3.481599l-0.512 0.2048L161.07527 219.136059c-14.438397 6.246399-24.012795 21.043196-24.012795 36.915192v229.939154c0 129.177574 56.934389 245.503951 160.358368 327.526335l191.027162 135.065573c13.670397 9.574398 32.767993 9.574398 46.43839 0l189.644762-133.683174c104.703979-82.175984 162.355168-198.75836 162.355168-328.243134V256.051251c0-15.871997-9.574398-30.668794-23.807995-36.812792l-334.796733-147.302371a39.664632 39.664632 0 0 0-16.383997-3.635199z"
                p-id="25667"></path>
            <path
                d="M705.279961 375.910427l-90.316782 90.316782c-15.718397 15.718397-41.420792 15.718397-57.087988 0-15.718397-15.718397-15.718397-41.420792 0-57.087988l90.316782-90.316782c15.718397-15.718397 41.420792-15.718397 57.087988 0 15.667197 15.718397 15.667197 41.420792 0 57.087988zM512.3584 568.831989l-135.833573 135.833572c-15.718397 15.718397-41.420792 15.718397-57.087988 0-15.718397-15.718397-15.718397-41.420792 0-57.087988l135.833572-135.833573-135.833572-135.833573c-15.718397-15.718397-15.718397-41.420792 0-57.087988 15.718397-15.718397 41.420792-15.718397 57.087988 0l328.703934 328.703934c15.718397 15.718397 15.718397 41.420792 0 57.087988-15.718397 15.718397-41.420792 15.718397-57.087988 0l-135.782373-135.782372z"
                p-id="25668"></path>
        </svg>)
}
const TargetLabel =({isTarget="",className=""})=> {
    return (<span className={`targetLabel flex-item-ver-center ${isTarget===0?" targetLabel_0":""}${isTarget===1?" targetLabel_1":""}${className?" "+className:""}`}>
      {isTarget===0?noVer():<i className={"ri-verified-badge-line font_20 mr_4"} />} {isTarget===0?Lang({id:"FeiMuBiaoYongHu",default:"非目标用户"}):(isTarget===1?Lang({id:"MuBiaoYongHu2",default:"目标用户"}):Lang({id:"ZanWeiQueRen",default:"暂未确认"}))}
    </span>)
}



export { TargetLabel,NewBuyerLabel,TransactionCustomerStage,InternalBuyerLabel};

